import { ValidatorFn, AbstractControl, FormArray } from '@angular/forms';

export class FormArrayValidators {
	public static atLeastOneItem(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			if (!(control.value as FormArray) || (control as FormArray).disabled) {
				return null;
			}

			let isValid = false;
			(control as FormArray).controls.forEach((formGroup) => {
				if (formGroup.get('value')?.value as boolean === true) {
					isValid = true;
					return;
				}
			});

			if (!isValid) {
				return {
					atLeastOneItemIsRequired: 'Please select at least one item',
				};
			}
			return null;
		};
	}
}
